<template>
	<div class="relative">
		<slot
			name="navigation"
			:set-active-item="setActiveItem"
			:active-item="activeItem"
		>
			<div
				v-if="count > 1"
				class="absolute left:0 -bottom-54 lg:bottom-32"
				:class="{
					'lg:left-auto lg:right-0': dotPosition === 'right',
				}"
			>
				<div
					v-for="(item, i) in count"
					:key="item"
					class="border-2 border-white
		border-solid w-12 h-12 rounded-full inline-block mr-8 cursor-pointer"
					:class="[activeItem === i && 'bg-white']"
					@click="activeItem = i"
				/>
			</div>
		</slot>
		<ul>
			<slot
				:active-item="activeItem"
				:set-active-item="setActiveItem"
			/>
		</ul>
	</div>
</template>

<script>
export default {
	props: {
		dotPosition: {
			type: String,
			default: 'right',
		},
	},
	data() {
		return {
			activeItem: 0,
			count: 0,
		};
	},
	mounted() {
		this.count = this.$children.length;
	},
	methods: {
		setActiveItem( index ) {
			this.activeItem = index;
		},
	},
};
</script>
